import { DashboardScheduleCard } from "./DashboardScheduleCard";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { DashboardInterview } from "@/types";

// Absolutely-positioned event inside a week-grid day column. left/width place
// overlapping events into side-by-side columns; pr-0.5 gives the seam its gutter.
export const DashboardScheduleWeekEvent = ({
  interview,
  topPx,
  heightPx,
  leftPct,
  widthPct,
  showOwnerAvatar = false,
  onSelect,
}: {
  interview: DashboardInterview;
  topPx: number;
  heightPx: number;
  leftPct: number;
  widthPct: number;
  showOwnerAvatar?: boolean;
  onSelect?: () => void;
}) => {
  const render = () => (
    <Popover>
      <PopoverTrigger asChild>
        <div
          className="absolute block pr-0.5 text-left"
          style={{
            top: topPx,
            height: heightPx,
            left: `${leftPct.toString()}%`,
            width: `${widthPct.toString()}%`,
          }}
        >
          <DashboardScheduleCard
            calendarHeightPx={heightPx}
            className="h-full w-full cursor-pointer hover:brightness-[0.97]"
            interview={interview}
            isCondensed={widthPct < 100}
            showOwnerAvatar={showOwnerAvatar}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="start"
        className="w-[240px] rounded-lg border-0 p-0 shadow-lg"
      >
        <DashboardScheduleCard
          className="ring-1 ring-lever-border-action"
          interview={interview}
          showOwnerAvatar={showOwnerAvatar}
          onSelect={onSelect}
        />
      </PopoverContent>
    </Popover>
  );

  return render();
};
